import { http, HttpResponse } from 'msw';

import { v4Resource } from '../helpers';

export const v4Transfers = [
    http.post(v4Resource('/transfers/card-to-account'), async () => {
        return HttpResponse.json({
            dynamicLinkId: { value: 'test' },
        });
    }),
];
